const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
"https://srinivasafleet.com/api";


const getToken = () => {
  const keys = [
    "token",
    "access_token",
    "accessToken",
    "auth_token",
    "authToken",
    "admin_token",
  ];

  for (const key of keys) {
    const localValue = localStorage.getItem(key);

    if (
      localValue &&
      localValue !== "null" &&
      localValue !== "undefined"
    ) {
      return localValue;
    }

    const sessionValue = sessionStorage.getItem(key);

    if (
      sessionValue &&
      sessionValue !== "null" &&
      sessionValue !== "undefined"
    ) {
      return sessionValue;
    }
  }

  return "";
};


const request = async (url, options = {}) => {
  const token = getToken();

  const headers = {
    Accept: "application/json",

    ...(options.body
      ? {
          "Content-Type": "application/json",
        }
      : {}),

    ...(token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {}),

    ...(options.headers || {}),
  };

  const response = await fetch(
    `${API_BASE_URL}${url}`,
    {
      ...options,
      headers,
    }
  );

  let data = null;

  const contentType =
    response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    try {
      data = await response.json();
    } catch {
      data = null;
    }
  } else {
    try {
      const text = await response.text();
      data = text || null;
    } catch {
      data = null;
    }
  }

  if (!response.ok) {
    let message =
      `Request failed with status ${response.status}`;

    if (response.status === 400) {
      if (typeof data?.detail === "string") {
        message = data.detail;
      } else if (Array.isArray(data?.detail)) {
        message = data.detail
          .map(
            (item) =>
              item?.msg ||
              item?.message ||
              String(item)
          )
          .join(", ");
      } else {
        message =
          data?.message ||
          "Invalid request.";
      }
    }

    /* 401 */
    else if (response.status === 401) {
      message =
        "Authentication failed. Please login again.";
    }

    /* 404 */
    else if (response.status === 404) {
      message =
        data?.detail ||
        "Penalty follow-up not found.";
    }

    /* 409 */
    else if (response.status === 409) {
      message =
        data?.detail ||
        "This penalty already exists for the selected vehicle, date and penalty type.";
    }

    /* 422 */
    else if (response.status === 422) {
      if (Array.isArray(data?.detail)) {
        message = data.detail
          .map(
            (item) =>
              item?.msg ||
              item?.message ||
              String(item)
          )
          .join(", ");
      } else {
        message =
          data?.detail ||
          data?.message ||
          "Validation failed.";
      }
    }

    /* 500 */
    else if (response.status === 500) {
      if (typeof data?.detail === "string") {
        message = data.detail;
      } else if (data?.detail?.message) {
        message = data.detail.message;
      } else {
        message =
          "Server error while processing the penalty request.";
      }
    }

    else if (response.status === 502) {
      if (
        typeof data?.detail === "object" &&
        data?.detail !== null
      ) {
        message =
          data.detail.message ||
          "SMS gateway request failed.";
      } else {
        message =
          data?.detail ||
          "SMS gateway request failed.";
      }
    }

    else if (Array.isArray(data?.detail)) {
      message = data.detail
        .map(
          (item) =>
            item?.msg ||
            item?.message ||
            String(item)
        )
        .join(", ");
    }

    else if (
      typeof data?.detail === "string"
    ) {
      message = data.detail;
    }

    /* Other message */
    else if (
      typeof data?.message === "string"
    ) {
      message = data.message;
    }

    else if (
      typeof data === "string" &&
      data
    ) {
      message = data;
    }

    throw new Error(message);
  }

  return data;
};


const unwrap = (result) => {
  if (
    result &&
    result.data !== undefined
  ) {
    return result.data;
  }

  return result;
};


const normalizePenaltyType = (item) => {
  const data = item || {};

  return {
    id: data.id,

    penaltyCode:
      data.penalty_code ||
      data.penaltyCode ||
      "",

    penaltyName:
      data.penalty_name ||
      data.penaltyName ||
      "",

    description:
      data.description || "",

    isActive:
      data.is_active !== false,
  };
};

const normalizePenaltyRecord = (record) => {
  const data =
    unwrap(record) || {};

  return {
    id: data.id,

    penaltyTypeId:
      data.penalty_type_id ??
      data.penaltyTypeId ??
      null,

    penaltyTypeName:
      data.penalty_type_name ||
      data.penaltyTypeName ||
      "",

    penaltyDate:
      data.penalty_date ||
      data.penaltyDate ||
      "",

    vehicleId:
      data.vehicle_id ??
      data.vehicleId ??
      null,

    vehicleAssignmentId:
      data.vehicle_assignment_id ??
      data.vehicleAssignmentId ??
      null,

    supplierId:
      data.supplier_id ??
      data.supplierId ??
      null,

    driverId:
      data.driver_id ??
      data.driverId ??
      null,

    cabNumber:
      data.vehicle_registration_number ||
      data.vehicle_display_number ||
      data.cab_number ||
      data.cabNumber ||
      "",

    vehicleRegistrationNumber:
      data.vehicle_registration_number ||
      data.vehicleRegistrationNumber ||
      "",

    vehicleDisplayNumber:
      data.vehicle_display_number ||
      data.vehicleDisplayNumber ||
      "",

    supplier:
      data.supplier_name ||
      data.supplier ||
      "",

    driver:
      data.driver_name ||
      data.driver ||
      "",

    supplierMobile:
      data.supplier_mobile ||
      data.supplierMobile ||
      "",

    driverMobile:
      data.driver_mobile ||
      data.driverMobile ||
      "",

    contacts: [
      data.supplier_mobile,
      data.supplierMobile,
      data.driver_mobile,
      data.driverMobile,
    ].filter(Boolean),

    vehicleType:
      data.vehicle_type ||
      data.vehicle_type_name ||
      data.vehicleType ||
      "",

    year:
      data.year ?? "",

    penaltyAmount:
      data.penalty_amount ??
      data.penaltyAmount ??
      0,

    remarks:
      data.penalty_remarks ||
      data.remarks ||
      "",

    smsSent: Boolean(
      data.sms_sent ??
        data.smsSent
    ),

    smsSentAt:
      data.sms_sent_at ||
      data.smsSentAt ||
      null,

    status:
      data.status ||
      "Pending",

    createdBy:
      data.created_by_name ||
      data.created_by ||
      data.createdByName ||
      data.createdBy ||
      "",

    updatedBy:
      data.updated_by_name ||
      data.updated_by ||
      data.updatedByName ||
      data.updatedBy ||
      "",

    createdAt:
      data.created_at ||
      data.createdAt ||
      "",

    updatedAt:
      data.updated_at ||
      data.updatedAt ||
      data.created_at ||
      data.createdAt ||
      "",
  };
};


const normalizeSearchResult = (result) => {
  const data =
    unwrap(result) || {};

  return {
    vehicleId:
      data.vehicle_id ??
      data.vehicleId ??
      null,

    vehicleAssignmentId:
      data.vehicle_assignment_id ??
      data.vehicleAssignmentId ??
      null,

    supplierId:
      data.supplier_id ??
      data.supplierId ??
      null,

    driverId:
      data.driver_id ??
      data.driverId ??
      null,

    cabNumber:
      data.vehicle_registration_number ||
      data.vehicle_display_number ||
      data.cab_number ||
      data.cabNumber ||
      "",

    vehicleRegistrationNumber:
      data.vehicle_registration_number ||
      data.vehicleRegistrationNumber ||
      "",

    vehicleDisplayNumber:
      data.vehicle_display_number ||
      data.vehicleDisplayNumber ||
      "",

    supplier:
      data.supplier_name ||
      data.supplier ||
      "",

    driver:
      data.driver_name ||
      data.driver ||
      "",

    supplierMobile:
      data.supplier_mobile ||
      data.supplierMobile ||
      "",

    driverMobile:
      data.driver_mobile ||
      data.driverMobile ||
      "",

    contacts: [
      data.supplier_mobile,
      data.supplierMobile,
      data.driver_mobile,
      data.driverMobile,
    ].filter(Boolean),

    vehicleType:
      data.vehicle_type ||
      data.vehicle_type_name ||
      data.vehicleType ||
      "",

    year:
      data.year ?? "",

    penaltyTypeId:
      data.penalty_type_id ??
      data.penaltyTypeId ??
      null,

    penaltyTypeName:
      data.penalty_type_name ||
      data.penaltyTypeName ||
      "",
  };
};


export const getPenaltyTypes =
  async () => {
    const result =
      await request(
        "/penalty-followups/types"
      );

    const data =
      unwrap(result);

    if (!Array.isArray(data)) {
      return [];
    }

    return data.map(
      normalizePenaltyType
    );
  };


export const searchPenaltyCab =
  async ({
    cabLast4,
    penaltyDate,
  }) => {

    const cleanCabLast4 =
      String(cabLast4 || "")
        .replace(/\D/g, "")
        .slice(0, 4);

    if (
      cleanCabLast4.length !== 4
    ) {
      throw new Error(
        "Enter exactly 4 digits of the cab number."
      );
    }

    if (!penaltyDate) {
      throw new Error(
        "Penalty date is required."
      );
    }

    const result =
      await request(
        "/penalty-followups/search-cab",
        {
          method: "POST",

          body: JSON.stringify({
            cab_last_4:
              cleanCabLast4,

            penalty_date:
              penaltyDate,
          }),
        }
      );

    return normalizeSearchResult(
      result
    );
  };

export const getPenaltyFollowups =
  async ({
    fromDate = "",
    toDate = "",
    penaltyTypeId = "",
    status = "",
  } = {}) => {

    const params =
      new URLSearchParams();

    if (fromDate) {
      params.set(
        "from_date",
        fromDate
      );
    }

    if (toDate) {
      params.set(
        "to_date",
        toDate
      );
    }

    if (penaltyTypeId) {
      params.set(
        "penalty_type_id",
        String(penaltyTypeId)
      );
    }

    if (status) {
      params.set(
        "status",
        status
      );
    }

    const query =
      params.toString();

    const result =
      await request(
        `/penalty-followups/${
          query
            ? `?${query}`
            : ""
        }`
      );

    const data =
      unwrap(result);

    if (!Array.isArray(data)) {
      return [];
    }

    return data.map(
      normalizePenaltyRecord
    );
  };


export const createPenaltyFollowup =
  async ({
    penaltyTypeId,
    penaltyDate,
    vehicleId,
    vehicleAssignmentId = null,
    supplierId = null,
    driverId = null,
    penaltyAmount = null,
    remarks = "",
    penaltyRemarks = "",
  }) => {

    if (!penaltyTypeId) {
      throw new Error(
        "Penalty type is required."
      );
    }

    if (!penaltyDate) {
      throw new Error(
        "Penalty date is required."
      );
    }

    if (!vehicleId) {
      throw new Error(
        "Vehicle is required."
      );
    }

    let finalAmount = null;

    if (
      penaltyAmount !== null &&
      penaltyAmount !== "" &&
      penaltyAmount !== undefined
    ) {
      finalAmount =
        Number(penaltyAmount);

      if (
        !Number.isFinite(finalAmount) ||
        finalAmount < 0
      ) {
        throw new Error(
          "Please enter a valid penalty amount."
        );
      }
    }
    const finalRemarks = (
      penaltyRemarks ??
      remarks ??
      ""
    ).trim();

    const result =
      await request(
        "/penalty-followups/",
        {
          method: "POST",

          body: JSON.stringify({
            penalty_type_id:
              Number(
                penaltyTypeId
              ),

            penalty_date:
              penaltyDate,

            vehicle_id:
              Number(vehicleId),

            vehicle_assignment_id:
              vehicleAssignmentId
                ? Number(
                    vehicleAssignmentId
                  )
                : null,

            supplier_id:
              supplierId
                ? Number(supplierId)
                : null,

            driver_id:
              driverId
                ? Number(driverId)
                : null,

            penalty_amount:
              finalAmount,

            penalty_remarks:
              finalRemarks,
          }),
        }
      );

    return normalizePenaltyRecord(
      result
    );
  };


export const updatePenaltyFollowup =
  async (
    followupId,
    {
      penaltyTypeId,
      penaltyDate,
      penaltyAmount,
      remarks,
      penaltyRemarks,
      status,
    }
  ) => {

    if (!followupId) {
      throw new Error(
        "Penalty follow-up ID is required."
      );
    }

    const payload = {};

    if (
      penaltyTypeId !== undefined &&
      penaltyTypeId !== null &&
      penaltyTypeId !== ""
    ) {
      payload.penalty_type_id =
        Number(penaltyTypeId);
    }

    if (penaltyDate) {
      payload.penalty_date =
        penaltyDate;
    }

    if (
      penaltyAmount !== undefined
    ) {

      if (
        penaltyAmount === null ||
        penaltyAmount === ""
      ) {

        payload.penalty_amount =
          null;

      } else {

        const amount =
          Number(penaltyAmount);

        if (
          !Number.isFinite(amount) ||
          amount < 0
        ) {
          throw new Error(
            "Please enter a valid penalty amount."
          );
        }

        payload.penalty_amount =
          amount;
      }
    }

    const finalRemarks =
      penaltyRemarks ??
      remarks;

    if (
      finalRemarks !== undefined
    ) {
      payload.penalty_remarks =
        String(
          finalRemarks
        ).trim();
    }

    if (
      status !== undefined
    ) {
      payload.status =
        status || null;
    }

    const result =
      await request(
        `/penalty-followups/${encodeURIComponent(
          followupId
        )}`,
        {
          method: "PUT",

          body:
            JSON.stringify(
              payload
            ),
        }
      );

    return normalizePenaltyRecord(
      result
    );
  };


export const markPenaltySmsSent =
  async (followupId) => {

    if (!followupId) {
      throw new Error(
        "Penalty follow-up ID is required."
      );
    }

    const result =
      await request(
        `/penalty-followups/${encodeURIComponent(
          followupId
        )}/sms-sent`,
        {
          method: "PATCH",
          body:
            JSON.stringify({}),
        }
      );

    const record =
      normalizePenaltyRecord(
        result
      );


    if (!record.smsSent) {
      throw new Error(
        "SMS gateway accepted the request, but SMS status was not updated."
      );
    }

    return record;
  };


export const markPenaltyPaid =
  async (followupId) => {

    if (!followupId) {
      throw new Error(
        "Penalty follow-up ID is required."
      );
    }

    const result =
      await request(
        `/penalty-followups/${encodeURIComponent(
          followupId
        )}/paid`,
        {
          method: "PATCH",
        }
      );

    return normalizePenaltyRecord(
      result
    );
  };



export default {
  getPenaltyTypes,
  searchPenaltyCab,
  getPenaltyFollowups,
  createPenaltyFollowup,
  updatePenaltyFollowup,
  markPenaltySmsSent,
  markPenaltyPaid,
};